var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 69",
    width: 69,
    height: 69,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,32,-29.412,0,23.158,19)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5000f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,32,-45.078,0,23.158,19)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5000f0"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: #5000f0 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m0 19h9.4l20 32h-4.6c-3 0-5.8-1.6-7.4-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m34 51h-4.6l7.5-12h9.4l-4.9 7.9c-1.6 2.5-4.4 4.1-7.4 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m68.8 51h-9.5l-20.4-32h4.6c3.1 0 5.9 1.6 7.6 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m34.2 19h4.7l-7.7 12h-9.5l5-7.9c1.6-2.5 4.5-4.1 7.5-4.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosm);
export default __webpack_public_path__ + "static/media/logosm.de6ad5236b21d62e30a775f27bdd1364.svg";
export { ForwardRef as ReactComponent };